import { createApp } from "vue"; // vue.esm-bundler.js, con compilador (webpack.mix.js)
import XIcons from "../icons/XIcons.vue";
import ProductDetails from "./ProductDetails.vue";
import { onCompilerError } from "./compilerErrors";

// La ficha es el UNICO bundle del front que no usa createPageApp:
//
//  1. Su raiz ES ProductDetails.vue, que declara `transPeralbaPro` como PROP;
//     el helper lo pondria ademas en el `data` de la raiz y Vue avisaria
//     ("Data property already defined in Props").
//  2. El componente de iconos aqui se llama <vue-icon>, no <x-icons>.
//  3. La plantilla no esta en el SFC: es el HTML que details.blade.php escribe
//     dentro de #product-details-app. Vue 3 usa `container.innerHTML` como
//     plantilla de la raiz solo si el componente no tiene `template` ni
//     `render`, y vue-loader no genera `render` para un SFC sin bloque
//     <template> (vue-loader/dist/index.js:134). Por eso ProductDetails.vue
//     NUNCA puede llevar un <template> (docs/frontend/product-page.md).
//     Sustituye a `inline-template`, que no existe en Vue 3.
//  4. Los props llegan en un <script type="application/json"> que emite el
//     Blade fuera del contenedor (Vue borra su innerHTML al montar).
const payload = document.getElementById("product-details-props");

if (!payload) {
    // El Blade y el bundle van juntos: si falta el JSON, el Blade que se
    // sirve no es el que espera este bundle.
    console.error(
        "product-details: falta #product-details-props; el Blade y el bundle no coinciden"
    );
} else {
    const app = createApp(ProductDetails, JSON.parse(payload.textContent));

    // El markup de la ficha lo compila el runtime, y ahi el espacio en blanco
    // entre elementos es visible (p.ej. "3 uds" en los almacenes alternativos,
    // details.blade.php). Vue 2 lo conserva como un espacio; Vue 3 lo borra por
    // defecto ("condense"): sin esta linea desaparecen 181 nodos de espacio
    // visibles de la ficha (fila 3.11 del plan de modernizacion). NO LA QUITES.
    app.config.compilerOptions.whitespace = "preserve";

    // Las replicas SSR del Blade son `<span v-text="x">texto</span>`: para el
    // compilador de Vue 3 eso es un error (57), que en produccion LANZA y deja
    // la ficha sin montar. Se toleran solo esos codigos (ver compilerErrors.js).
    app.config.compilerOptions.onError = onCompilerError;

    app.component("vue-icon", XIcons);

    app.mount("#product-details-app");
}
